import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFormatBoldComponent } from "./med-icon-format-bold.component";

@NgModule({
  declarations: [
    MedIconFormatBoldComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFormatBoldComponent,
  ],
})
export class MedIconFormatBoldModule { }
